const pages = ["settings", "Game Rules", "Provably Fair", "History", "SetStake", "Auto"]

export const usePages = (enableLoading: boolean) => {
    return enableLoading
        ? pages
        : [];

}